export default {
  tokenInvalid: 'The access token is invalid',
  uploadSku: 'Uploaded excel contains repeat SKU: ',
  blankCode: 'Excel contains blank product code',
  blanksCode: 'There are blanks in product code: ',
  requestError: 'Request error',
  timeOut: 'Gateway Time-out',
  code404: 'Request failed with status code 404',
  loginNameExists: 'Login name or mailbox already exists',
  codeInvalid: 'The authorization code is invalid or has expired',
  accountExpired: 'User account has expired',
  notNfcUser: 'Not a system specific user',
  systemError: 'Unknown system exception',
  sourceFileIsEmpty: 'Source file is empty',
  sourceDirIsEmpty: 'Source dir is empty',
  configError: 'SKU list file path config error',
  insertError: 'Batch insert nsp sku error'
  // repeatSKU: 'Uploaded excel contains repeat SKU'
}
